export interface SkippedFile { name: string; reason: 'not_audio' | 'too_large'; }

// Formate, die der client-seitige ffmpeg-Converter (audioConvert.ts) verarbeiten kann.
// Alles wird vor dem Upload zu normalisiertem MP3 192k konvertiert.
const AUDIO_RE = /\.(mp3|wav|m4a|aac|ogg|oga|opus|flac|aif|aiff|wma|mp4|caf|amr)$/i;

// Trennt eine Datei-Auswahl in akzeptierte (Audio + unter Limit) und übersprungene.
export function classifyAudioFiles(files: File[], maxBytes: number): { accepted: File[]; skipped: SkippedFile[] } {
  const accepted: File[] = [];
  const skipped: SkippedFile[] = [];
  for (const f of files) {
    if (!AUDIO_RE.test(f.name)) skipped.push({ name: f.name, reason: 'not_audio' });
    else if (f.size > maxBytes) skipped.push({ name: f.name, reason: 'too_large' });
    else accepted.push(f);
  }
  return { accepted, skipped };
}
